import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, CheckCircle } from 'lucide-react';
export function CTASection() {
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormState('submitting');
    // Simulate API call
    setTimeout(() => {
      setFormState('success');
    }, 1500);
  };
  return <section id="schedule" className="py-24 bg-gray-50 relative overflow-hidden" data-id="element-35">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-36">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-37">
          <div className="grid md:grid-cols-5" data-id="element-38">
            {/* Left Side - Info */}
            <div className="md:col-span-2 bg-black text-white p-10 flex flex-col justify-between relative overflow-hidden" data-id="element-39">
              <div className="relative z-10" data-id="element-40">
                <h3 className="text-2xl font-bold mb-4" data-id="element-41">Start Your Journey</h3>
                <p className="text-gray-400 mb-8" data-id="element-42">
                  Schedule your free trial class today. No obligation, just an
                  opportunity to see if we're the right fit for you.
                </p>
                <div className="space-y-4" data-id="element-43">
                  <div className="flex items-start gap-3" data-id="element-44">
                    <div className="w-8 h-8 rounded-full bg-[#00D4FF]/20 flex items-center justify-center text-[#00D4FF] font-bold text-sm" data-id="element-45">
                      1
                    </div>
                    <p className="text-sm text-gray-300 pt-1" data-id="element-46">
                      Fill out the form
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-47">
                    <div className="w-8 h-8 rounded-full bg-[#00D4FF]/20 flex items-center justify-center text-[#00D4FF] font-bold text-sm" data-id="element-48">
                      2
                    </div>
                    <p className="text-sm text-gray-300 pt-1" data-id="element-49">
                      We'll contact you to confirm
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-50">
                    <div className="w-8 h-8 rounded-full bg-[#00D4FF]/20 flex items-center justify-center text-[#00D4FF] font-bold text-sm" data-id="element-51">
                      3
                    </div>
                    <p className="text-sm text-gray-300 pt-1" data-id="element-52">
                      Come in for your free class!
                    </p>
                  </div>
                </div>
              </div>

              {/* Abstract background shapes */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-[#00D4FF] opacity-10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-53" />
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#FF6B35] opacity-10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-54" />
            </div>

            {/* Right Side - Form */}
            <div className="md:col-span-3 p-10" data-id="element-55">
              {formState === 'success' ? <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="h-full flex flex-col items-center justify-center text-center p-6" data-id="element-56">
                  <div className="w-16 h-16 bg-green-100 text-green-500 rounded-full flex items-center justify-center mb-4" data-id="element-57">
                    <CheckCircle size={32} data-id="element-58" />
                  </div>
                  <h4 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-59">
                    Message Sent!
                  </h4>
                  <p className="text-gray-600" data-id="element-60">
                    We'll be in touch shortly to schedule your visit.
                  </p>
                  <button onClick={() => setFormState('idle')} className="mt-8 text-[#00D4FF] font-bold hover:underline" data-id="element-61">
                    Send another message
                  </button>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-62">
                  <div data-id="element-63">
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-64">
                      Full Name
                    </label>
                    <input type="text" id="name" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" placeholder="John Doe" data-id="element-65" />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-66">
                    <div data-id="element-67">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-68">
                        Email
                      </label>
                      <input type="email" id="email" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" placeholder="john@example.com" data-id="element-69" />
                    </div>
                    <div data-id="element-70">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-71">
                        Phone
                      </label>
                      <input type="tel" id="phone" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" placeholder="(309) 555-0123" data-id="element-72" />
                    </div>
                  </div>

                  <div data-id="element-73">
                    <label htmlFor="program" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-74">
                      Interested Program
                    </label>
                    <select id="program" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all bg-white" data-id="element-75">
                      <option value="little-tigers" data-id="element-76">
                        Little Tigers (Ages 3-5)
                      </option>
                      <option value="kids" data-id="element-77">Kids & Teens (Ages 6-17)</option>
                      <option value="adults" data-id="element-78">Adults (18+)</option>
                      <option value="unsure" data-id="element-79">Not Sure Yet</option>
                    </select>
                  </div>

                  <div data-id="element-80">
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-81">
                      Message (Optional)
                    </label>
                    <textarea id="message" rows={3} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all resize-none" placeholder="Any specific questions or goals?" data-id="element-82"></textarea>
                  </div>

                  <button type="submit" disabled={formState === 'submitting'} className="w-full bg-[#00D4FF] text-black font-bold py-4 rounded-lg uppercase tracking-wider hover:bg-[#33ddff] transition-colors flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-83">
                    {formState === 'submitting' ? 'Sending...' : 'Schedule Visit'}
                    {!formState && <Send size={18} data-id="element-84" />}
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}